import { useState } from "react";
import { Button } from "../../components/common/Button";
import { Header } from "../../components/common/Header";
import { DeleteProgram } from "../../components/DeleteProgram";
import { Info } from "../../components/Info";
import { ModalOverlay } from "../../components/ModalOverlay";
import { Plan } from "../../components/Plan";
import styles from "./StartupRegistrationDetail.module.scss";
import { GreetingsHeader } from '../../components/common/GreetingsHeader';

//mock

const plan = [
  {
    week: "1",
    description: [
      {
        title: "Kick-off",
        text: "Maak kennis met elkaar en krijg een beeld van de werkwijze tijdens het programma.",
      },
      {
        title: "Visie",
        text: "Onderzoek de belangrijkste trends en ontwikkelingen voor jouw start-up en scherp je visie aan. Dit vormt je fundament tijdens het programma",
      },
    ],
    groupForm: "Collectief ",
    location: "Station 88, Tilburg",
    start: "13:00 ",
    end: "16:00",
    date: new Date(),
  },
  {
    week: "2",
    description: [
      {
        title: "Problem discovery",
        text: "Onderzoek de belangrijkste trends en ontwikkelingen voor jouw start-up en scherp je visie aan. Dit vormt je fundament tijdens het prgramma.",
      },
      {
        title: "Intellectueel eigendom",
        text: "Indentificeer kansen en risico’s op het gebied van intellectueel eigendom voor je start-up.",
      },
    ],
    groupForm: "Collectief ",
    location: "Station 88, Tilburg",
    start: "13:00 ",
    end: "16:00",
    date: new Date(),
  },
  {
    week: "3",
    description: [
      {
        title: "Problem validation",
        text: "Deel de voortgang van jouw marktverkenning, maak het klantprobleem meer specifiek en valideer het bij potentiële klanten.",
      },
    ],
    groupForm: "Collectief ",
    location: "Station 88, Tilburg",
    start: "13:00 ",
    end: "16:00",
    date: new Date(),
  },
  {
    week: "4",
    description: [
      {
        title: "Problem-solution fit",
        text: "Maak een demo van je oplossing en toets deze bij potentiële klanten.",
      },
    ],
    groupForm: "Collectief ",
    location: "Station 88, Tilburg",
    start: "13:00 ",
    end: "16:00",
    date: new Date(),
  },
  {
    week: "5",
    description: [
      {
        title: "Businessmodle voorkant",
        text: "Presenteer jouw bevindingen en conclusies, scherp jouw aannames over je verkoopkanalen, klantrelaties en verdienmdel aan en toets ze bij klanten.",
      },
    ],
    groupForm: "Collectief ",
    location: "Station 88, Tilburg",
    start: "13:00 ",
    end: "16:00",
    date: new Date(),
  },
  {
    week: "6",
    description: [
      {
        title: "Businesssmodel achterkant",
        text: "Maak inzichtelijk welke activiteiten, middelen en partners nodig zijn en hoe je kosten beheerst om het businessmodel winstgevend te maken.",
      },
    ],
    groupForm: "Collectief ",
    location: "Station 88, Tilburg",
    start: "13:00 ",
    end: "16:00",
    date: new Date(),
  },
  {
    week: "7",
    description: [
      {
        title: "Team",
        text: "Toets of de activiteiten van je team in balans zijn met de levensfase van je start-up en krijg inzicht in de prioriteiten van je team.",
      },
    ],
    groupForm: "Collectief ",
    location: "Station 88, Tilburg",
    start: "13:00 ",
    end: "16:00",
    date: new Date(),
  },
  {
    week: "8",
    description: [
      {
        title: "Financieringsbehoefte",
        text: "Breng je financieringsbehoefte in kaart en stel een exploitatie-, liquiditeits- en investerignsbegroting op.",
      },
    ],
    groupForm: "Collectief ",
    location: "Station 88, Tilburg",
    start: "13:00 ",
    end: "16:00",
    date: new Date(),
  },
  {
    week: "9",
    description: [
      {
        title: "Financieringsstrategie",
        text: "Bepaal jouw financieringsstrategie en stel een financieringsaanvraag op.",
      },
    ],
    groupForm: "Collectief ",
    location: "Station 88, Tilburg",
    start: "13:00 ",
    end: "16:00",
    date: new Date(),
  },
  {
    week: "10",
    description: [
      {
        title: "Afsluiting",
        text: "Presenteer jouw Pitch Deck en deel jouw inzichten met de andere deelnemers",
      },
    ],
    groupForm: "Collectief ",
    location: "Station 88, Tilburg",
    start: "13:00 ",
    end: "16:00",
    date: new Date(),
  },
];

export const StartupRegistrationDetail = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.wrapper}>
      <GreetingsHeader title="Hallo <me.name>, welkom bij" subtitle="Aanmelding - Investor Readiness Programm" />
      <section className={styles.infoContainer}>
        <Info
          title="PLANNINGEN"
          description="Bekijk hieronder de planning van het programma. Importeer alle details direct in je agenda. Van gedachte veranderd? Geen probleem! Via deze pagina kan jij je afmelden. Terug naar het overzicht met alle aanmeldingen kan via de knop rechts bovenin jouw scherm."
          element={<Button className="simple">Start aanmelding</Button>}
        />
      </section>
      <section className={styles.plan}>
        <h2 className={styles.planTitle}>PlANNING - WEEK OVERZICHT</h2>
        <h3 className={styles.planSubtitle}>
          Investor Readiness Programma Editie 18 | 22 juni - 24 augustus 2022
        </h3>
        <div className={styles.planItem}>
          {/* {plan.map((item) => (
            <Plan weekDetails={item} key={item.week} />
          ))} */}
        </div>
        <div className={styles.planButtons}>
          <Button className="dark">Importeer agenda</Button>
          <Button className="dark" onClick={() => setIsOpen(!isOpen)}>
            Afmelden
          </Button>
        </div>
      </section>
      <ModalOverlay show={isOpen}>
        <DeleteProgram
          onToggle={() => setIsOpen(!isOpen)}
          //mock id
          id={1}
          // onDelete={() => {}}
        />
      </ModalOverlay>
    </div>
  );
};
